export const formatBuildingLabel = (label) => {
  if (label === null || label === undefined) return "";

  const str = String(label).trim();

  // If it already starts with "Building" (case-insensitive), return as is
  if (/^building\b/i.test(str)) {
    return str;
  }

  // Otherwise, prefix "Building" to every label
  return `Building ${str}`;
};

export const getBuildingNoNumericValue = (buildingNo) => {
  const matches = String(buildingNo || '').match(/\d+/g);
  if (!matches || matches.length === 0) return 0;
  const lastMatch = matches[matches.length - 1];
  const parsed = parseInt(lastMatch, 10);
  return isNaN(parsed) ? 0 : parsed;
};

export const sortBuildings = (buildingsList) => {
  if (!Array.isArray(buildingsList)) return [];

  return [...buildingsList].sort((a, b) => {
    const valA = getBuildingNoNumericValue(a?.building_no);
    const valB = getBuildingNoNumericValue(b?.building_no);
    if (valA !== valB) {
      return valA - valB;
    }
    // Secondary alphabetical sort
    return String(a?.building_no || '').localeCompare(String(b?.building_no || ''), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  });
};
